module.exports = __webpack_public_path__ + "./Adam_cf25bf1cd68254e6a9f707b562e784dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2021/Adam.jpg
// module id = 514
// module chunks = 0